import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { secStyle } from "../lib/layout";

const iconCls = "group w-12 h-12 flex items-center justify-center border border-line text-vellum-muted hover:text-crimson hover:border-crimson transition-colors";

export default function Footer() {
  const { content } = useContent();
  const f = content.footer;
  const connect = [
    f.instagram_url && { key: "instagram", href: f.instagram_url, label: "Instagram", Icon: Instagram },
    f.youtube_url && { key: "youtube", href: f.youtube_url, label: "YouTube", Icon: Youtube },
    f.email && { key: "email", href: `mailto:${f.email}`, label: `Email ${f.email}`, Icon: Mail },
  ].filter(Boolean);

  return (
    <footer className="bg-ink-800 mt-0" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-20 lg:py-28" style={secStyle(content, "footer")}>
        <div className="grid md:grid-cols-3 gap-12 lg:gap-16">
          <div>
            <p className="overline mb-6">Here</p>
            <ul className="space-y-3">
              {[["/", "Home"], ["/library", "The Library"], ["/curriculums", "Personal Curriculums"]].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="font-serif text-xl text-vellum hover:text-brass transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="overline mb-6">Elsewhere</p>
            <ul className="space-y-3">
              <li><a href={f.book_link_url} target="_blank" rel="noreferrer" className="font-serif text-xl text-vellum hover:text-brass transition-colors">{f.book_link_label}</a></li>
              <li><Link to="/privacy" className="font-serif text-xl text-vellum hover:text-brass transition-colors" data-testid="footer-privacy-link">Privacy</Link></li>
              <li><Link to="/terms" className="font-serif text-xl text-vellum hover:text-brass transition-colors" data-testid="footer-terms-link">Terms</Link></li>
              <li className="pt-2"><Link to="/admin" className="font-mono text-xs uppercase tracking-[0.2em] text-vellum-faint hover:text-vellum transition-colors" data-testid="footer-admin-link">Curator Access</Link></li>
            </ul>
          </div>
          {connect.length > 0 && (
            <div className="md:justify-self-end" data-testid="footer-connect">
              <p className="overline mb-6">Connect with me</p>
              <div className="flex items-center gap-3">
                {connect.map(({ key, href, label, Icon }) => (
                  <a
                    key={key}
                    href={href}
                    target={key === "email" ? undefined : "_blank"}
                    rel={key === "email" ? undefined : "noreferrer"}
                    aria-label={label}
                    title={label}
                    data-testid={`footer-${key}-link`}
                    className={iconCls}
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="mt-20 pt-8 border-t border-line flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-mono text-xs text-vellum-faint uppercase tracking-[0.2em]">© {new Date().getFullYear()} Tirthak Saha</p>
          <p className="font-mono text-xs text-vellum-faint uppercase tracking-[0.2em]">{f.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
